import cardView from './components/CardView.vue'
import tableView from './components/TableView.vue'
import cardEdit from './components/CardEdit.vue'
import searchResultPanel from './components/SearchResultPanel.vue'
import searchView from './components/SearchView.vue'

export const CardView = cardView
export const TableView = tableView
export const CardEdit = cardEdit
export const SearchResultPanel = searchResultPanel
export const SearchView = searchView
